import { render, staticRenderFns } from "./cv-breadcrumb-skeleton.vue?vue&type=template&id=3534c459&"
import script from "./cv-breadcrumb-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-breadcrumb-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports